import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { FiX } from "react-icons/fi";
import "./PopupForm.css";

const PopupForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      email: formData.email,
      message: formData.message,
    };

    emailjs
      .send("service_hfjuhy8", "template_cv0fu57", templateParams, "AKDzfoXfa9922wbXV")
      .then(
        (result) => {
          console.log(result.text);
          setStatus("Message sent successfully!");
          setFormData({ email: "", message: "" });
        },
        (error) => {
          console.log(error.text);
          setStatus("Failed to send message. Please try again.");
        }
      );
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("popup-overlay")) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-container">
        <button
          className="close-button"
          onClick={onClose}
          aria-label="Close modal"
        >
          <FiX />
        </button>

        <div className="popup-header">
          <h3 className="popup-heading">Get in Touch</h3>
        </div>

        {status && (
          <p
            className={`status-message ${
              status.includes("successfully") ? "success" : "error"
            }`}
          >
            {status}
          </p>
        )}

        <form onSubmit={handleSubmit} className="popup-form">
          <div className="form-group">
            <label className="popup-label" htmlFor="popup-email">
              Your Email
            </label>
            <input
              id="popup-email"
              type="email"
              name="email"
              placeholder="name@example.com"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="popup-label" htmlFor="popup-message">
              Message
            </label>
            <textarea
              id="popup-message"
              name="message"
              placeholder="How can we help you?"
              value={formData.message}
              onChange={handleInputChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="submit-button">
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default PopupForm;
